export const isStatsData = (obj: any): obj is StatsData => {
    return (obj as StatsData).total !== undefined || (obj as StatsData).current !== undefined;
}
